import { render, staticRenderFns } from "./BranchMain.vue?vue&type=template&id=531c3990&scoped=true&"
import script from "./BranchMain.vue?vue&type=script&lang=js&"
export * from "./BranchMain.vue?vue&type=script&lang=js&"
import style0 from "./BranchMain.vue?vue&type=style&index=0&id=531c3990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531c3990",
  null
  
)

export default component.exports